
// import founderImg from "../../Assets/images/founder.png";
import founderPic from "../../Assets/about/founderpic.jpeg";
import certificate1 from "../../Assets/about/certificate.jpeg";
import certificate2 from "../../Assets/about/certificate3.jpeg";
import medalsImg from "../../Assets/about/medals.jpeg";
import medal2Img from "../../Assets/about/medal2.jpeg";
import youtubeImg from "../../Assets/about/youtube.jpeg";
import { motion } from "framer-motion";
import {
  FaMapMarkedAlt,
  FaLandmark,
  FaTractor,
  FaGavel,
  FaTheaterMasks,
  FaHashtag,
  FaHospitalAlt,
  FaBriefcase,
  FaCloudSunRain,
} from "react-icons/fa";
import {
  FaSearch,
  FaLanguage,
  FaBolt,
  FaHeart,
  FaNewspaper,
} from "react-icons/fa";


import React from "react";

const About = () => {
  return (
    <div className="bg-gray-50 text-gray-800">
      {/* ================= HERO ================= */}
      <section className="bg-gradient-to-r from-red-700 to-black text-white py-24">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4">
            🗞️ Bundeli Chugli & Hindi Chugli
          </h1>
          <p className="text-xl italic mb-6">
            “Bundelkhand ki awaaz, sach ke saath.”
          </p>
          <p className="max-w-4xl mx-auto text-lg leading-relaxed">
            Bundeli Chugli & Hindi Chugli एक स्वतंत्र डिजिटल समाचार मंच है,
            जो बुंदेलखंड की मिट्टी से जुड़ी सच्ची आवाज़ को देश-दुनिया तक पहुँचाने का काम करता है।
            हम बुंदेलखंड, मध्य प्रदेश और उत्तर प्रदेश की ज़मीनी हकीकत से जुड़ी
            निष्पक्ष, बेबाक और विश्वसनीय ख़बरें
            बिना किसी डर, दबाव या पक्षपात के आप तक पहुँचाते हैं।
          </p>
        </div>
      </section>
      {/* ================= ABOUT ================= */}
      <section className="py-24 bg-gradient-to-b from-white via-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4">

          <div className="grid grid-cols-1 md:grid-cols-2 gap-14 items-center">

            {/* LEFT CONTENT */}
            <div>
              <h2 className="text-4xl font-extrabold mb-6 text-red-700 flex items-center gap-2">
                🧾 हमारे बारे में
              </h2>

              <p className="text-lg leading-relaxed mb-6 text-gray-700">
                <span className="font-semibold text-gray-900">
                  Bundeli Chugli & Hindi Chugli
                </span>{" "}
                की शुरुआत इस सोच के साथ हुई कि गाँव, क़स्बों और छोटे क्षेत्रों की
                आवाज़ भी उतनी ही महत्वपूर्ण है, जितनी शहरों की बड़ी ख़बरें।
              </p>

              <p className="text-lg leading-relaxed mb-6 text-gray-700">
                हम मानते हैं कि असली पत्रकारिता वही है जो ज़मीन से जुड़कर काम करे,
                जहाँ लोगों की समस्याओं, सफलताओं और संघर्षों को बिना किसी तोड़-मरोड़
                के ईमानदारी से सामने रखा जाए।
              </p>

              <p className="text-lg leading-relaxed text-gray-800 font-medium">
                इसी वजह से <span className="text-red-700 font-semibold">
                  Bundeli Chugli
                </span>{" "}
                केवल एक न्यूज़ वेबसाइट नहीं, बल्कि आम जनता के विश्वास की आवाज़
                बनने का एक प्रयास है।
              </p>
            </div>

            {/* RIGHT HIGHLIGHT BOX */}
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-red-600 to-black rounded-3xl blur-xl opacity-20" />

              <div className="relative bg-white rounded-3xl p-10 shadow-xl border border-gray-100
                        hover:-translate-y-2 transition-all duration-500">

                <h3 className="text-2xl font-bold text-gray-900 mb-6">
                  🗞️ हमारी सोच
                </h3>

                <ul className="space-y-4 text-lg text-gray-700">
                  <li>✔️ ज़मीनी और सच्ची पत्रकारिता</li>
                  <li>✔️ बिना डर और दबाव की ख़बरें</li>
                  <li>✔️ आम लोगों की आवाज़</li>
                  <li>✔️ बुंदेलखंड की असली तस्वीर</li>
                </ul>

                <div className="mt-8 h-1 w-20 bg-red-600 rounded-full" />
              </div>
            </div>

          </div>

        </div>
      </section>
      {/* ================= HERO (IMAGE + CONTENT) ================= */}
      <section className="bg-white py-24 border-t">
        <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-14 items-center">

          {/* Founder Image */}
          <div>
            <img
              src={founderPic}
              alt="Neeraj Soni - Founder Bundeli Chugli"
              className="rounded-xl shadow-lg w-full object-cover"
            />
            <p className="text-sm text-gray-500 mt-2">
              नीरज सोनी | संस्थापक, Bundeli Chugli
            </p>
          </div>

          {/* Founder Content */}
          <div>
            <h2 className="text-4xl font-extrabold text-red-700 mb-6">
              ✍️ नीरज सोनी
            </h2>

            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              नीरज सोनी पत्रकारिता क्षेत्र में एक स्थापित और ख्यातिलब्ध नाम हैं।
              उन्होंने अपने करियर की शुरुआत <strong>कार्टूनिस्ट</strong> के रूप में की
              और वर्ष <strong>1998</strong> से सक्रिय पत्रकारिता में प्रवेश किया।
            </p>

            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              <strong>2004 से 2016</strong> तक देश के प्रमुख समाचार पत्र समूहों में
              रिपोर्टर, ब्यूरो चीफ और सिटी हेड जैसे पदों पर रहते हुए
              उन्होंने ज़मीनी पत्रकारिता को मजबूती दी।
            </p>

            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              राजस्थान पत्रिका समूह में सेवाएं देने के बाद उन्होंने
              <span className="font-semibold text-red-700"> “बुंदेली चुगली”</span>
              की स्थापना की, जिसने बुंदेली भाषा की डिजिटल पत्रकारिता को नई पहचान दी।
            </p>

            <p className="text-lg font-semibold text-gray-900">
              आज Bundeli Chugli, छतरपुर और भोपाल से संचालित होकर
              बुंदेलखंड की सशक्त और विश्वसनीय आवाज़ बन चुका है।
            </p>
          </div>

        </div>
      </section>
 <section className="bg-[#fafafa] py-28">
  <div className="max-w-7xl mx-auto px-4">

    {/* Heading */}
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="max-w-3xl mb-20"
    >
      <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5">
        हमारी पहचान
      </h2>
      <p className="text-xl text-gray-700 leading-relaxed">
        <strong>Bundeli Chugli</strong> की पत्रकारिता को
        विभिन्न संस्थानों और डिजिटल मंचों द्वारा
        औपचारिक मान्यता प्राप्त है।
      </p>
    </motion.div>

    {/* Items */}
    <div className="space-y-24">

      {[
        {
          img: certificate1,
          title: "देवर्षि नारद पत्रकारिता पुरस्कार",
          meta: "विश्व संवाद केंद्र · 2023",
          text: "इलेक्ट्रॉनिक मीडिया में जनहित और ज़मीनी पत्रकारिता हेतु सम्मान।",
        },
        {
          img: certificate2,
          title: "पत्रकारिता सम्मान प्रमाण-पत्र",
          meta: "संस्थागत मान्यता",
          text: "निष्पक्ष, निर्भीक और तथ्यपरक रिपोर्टिंग के लिए प्रदत्त।",
        },
        {
          img: medalsImg,
          title: "विविध पत्रकारिता सम्मान",
          meta: "क्षेत्रीय एवं राष्ट्रीय स्तर",
          text: "खोजी रिपोर्टिंग और क्षेत्रीय पत्रकारिता में योगदान।",
        },
        {
          img: medal2Img,
          title: "संपादकीय उत्कृष्टता सम्मान",
          meta: "मीडिया संस्थान",
          text: "पत्रकारिता नैतिकता और स्वतंत्र संपादन के लिए मान्यता।",
        },
        {
          img: youtubeImg,
          title: "YouTube सिल्वर क्रिएटर अवार्ड",
          meta: "1,00,000+ सत्यापित दर्शक",
          text: "डिजिटल न्यूज़ मंच पर विश्वसनीय ऑडियंस बनाने की वैश्विक पहचान।",
        },
      ].map((item, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: index * 0.05 }}
          viewport={{ once: true }}
          className="grid md:grid-cols-2 gap-14 items-center"
        >
          {/* Image (FULL, NO CUT) */}
          <div className="bg-white rounded-xl shadow-md p-6 flex justify-center">
            <img
              src={item.img}
              alt={item.title}
              className="max-h-[360px] object-contain"
            />
          </div>

          {/* Text */}
          <div>
            <p className="text-sm font-semibold text-red-600 mb-2">
              {item.meta}
            </p>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              {item.title}
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              {item.text}
            </p>
          </div>
        </motion.div>
      ))}

    </div>

  </div>
</section>

      {/* ================= VISION ================= */}
      <section className="py-24 bg-gradient-to-b from-gray-50 via-white to-gray-100">
        <div className="max-w-7xl mx-auto px-4">

          {/* Heading */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-extrabold text-red-700 flex items-center justify-center gap-3">
              🔭 हमारा विज़न
            </h2>
            <div className="mt-4 h-1 w-28 bg-red-600 mx-auto rounded-full" />
          </div>

          {/* Vision Card */}
          <div className="max-w-4xl mx-auto relative group">

            {/* Glow Background */}
            <div className="absolute inset-0 bg-gradient-to-br from-red-600 to-black rounded-3xl blur-2xl opacity-20 
                      group-hover:opacity-30 transition-all duration-700" />

            {/* Main Card */}
            <div
              className="
          relative bg-white/80 backdrop-blur-xl
          rounded-3xl p-12 md:p-14
          shadow-xl border border-gray-200
          text-center
          hover:-translate-y-2 hover:shadow-2xl
          transition-all duration-500
        "
            >

              {/* Animated Icon */}
              <div
                className="
            w-24 h-24 mx-auto mb-8 rounded-full
            flex items-center justify-center text-5xl
            bg-gradient-to-br from-red-600 to-black text-white
            shadow-lg
            group-hover:scale-110 group-hover:rotate-6
            transition-all duration-500
          "
              >
                🔭
              </div>

              {/* Vision Text */}
              <p className="text-xl md:text-2xl leading-relaxed text-gray-800 font-medium">
                हमारा विज़न एक ऐसा डिजिटल मीडिया प्लेटफ़ॉर्म बनाना है
                जो <span className="font-semibold text-red-700">बुंदेलखंड की पहचान</span> बने,
                जहाँ <span className="font-semibold">सच, साहस और समर्पण</span> के साथ
                पत्रकारिता की जाए और
                हर नागरिक को अपनी बात रखने का समान अवसर मिले।
              </p>

              {/* Bottom Accent */}
              <div className="mt-10 h-1 w-24 bg-red-600 mx-auto rounded-full
                        group-hover:w-40 transition-all duration-500" />
            </div>
          </div>

        </div>
      </section>

      {/* ================= MISSION ================= */}
      <section className="py-24 bg-gradient-to-b from-gray-100 via-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4">

          {/* Heading */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-extrabold text-red-700 flex items-center justify-center gap-3">
              🎯 हमारा उद्देश्य
            </h2>
            <div className="mt-4 h-1 w-28 bg-red-600 mx-auto rounded-full" />
          </div>

          {/* Mission Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-6xl mx-auto">
            {[
              "सच्ची और निष्पक्ष ख़बरें प्रस्तुत करना",
              "बुंदेलखंड की स्थानीय ख़बरों को राष्ट्रीय स्तर तक पहुँचाना",
              "सामाजिक और जनहित से जुड़े मुद्दों को प्रमुखता से उठाना",
              "आम जनता और प्रशासन के बीच एक मजबूत सेतु बनना",
              "फ़ेक न्यूज़, अफ़वाहों और भ्रम से दूर रहना",
              "पत्रकारिता के मूल्यों को जीवित रखना",
            ].map((text, index) => (
              <div
                key={index}
                className="
            group relative rounded-3xl p-[2px]
            bg-gradient-to-br from-red-600 to-black
            hover:scale-[1.04]
            transition-transform duration-500
          "
              >
                <div
                  className="
              bg-white rounded-3xl p-8 h-full
              shadow-lg group-hover:shadow-2xl
              transition-all duration-500
            "
                >
                  {/* Icon */}
                  <div
                    className="
                w-14 h-14 mb-6 rounded-full
                flex items-center justify-center text-xl font-bold
                bg-red-600 text-white
                shadow-md
                group-hover:rotate-6 group-hover:scale-110
                transition-all duration-500
              "
                  >
                    ✓
                  </div>
                  {/* Text */}
                  <p className="text-lg font-medium text-gray-800 leading-relaxed">
                    {text}
                  </p>
                  {/* Accent */}
                  <div className="mt-6 h-1 w-14 bg-red-600 rounded-full
                            group-hover:w-24 transition-all duration-500" />
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* ================= COVERAGE ================= */}
   <section className="py-24 bg-gradient-to-b from-gray-50 via-white to-gray-100">
  <div className="max-w-7xl mx-auto px-4">

    {/* Heading */}
    <div className="text-center mb-16">
      <h2 className="text-4xl md:text-5xl font-extrabold text-red-700">
        हम क्या कवर करते हैं
      </h2>
      <p className="mt-4 text-gray-600 text-lg max-w-2xl mx-auto">
        बुंदेलखंड से लेकर राष्ट्रीय मुद्दों तक — सच, ज़मीन और जनता की आवाज़ के साथ
      </p>
    </div>

    {/* Cards */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
      {[
        {
          icon: <FaMapMarkedAlt />,
          text: "स्थानीय समाचार",
          color: "from-red-500 to-red-700",
        },
        {
          icon: <FaLandmark />,
          text: "राजनीति एवं सरकारी योजनाएँ",
          color: "from-indigo-500 to-indigo-700",
        },
        {
          icon: <FaTractor />,
          text: "किसान, गाँव एवं ग्रामीण समस्याएँ",
          color: "from-green-500 to-green-700",
        },
        {
          icon: <FaGavel />,
          text: "अपराध, कानून एवं ग्राउंड रिपोर्ट",
          color: "from-gray-700 to-black",
        },
        {
          icon: <FaTheaterMasks />,
          text: "संस्कृति, परंपरा एवं इतिहास",
          color: "from-yellow-500 to-orange-600",
        },
        {
          icon: <FaHashtag />,
          text: "सोशल मीडिया, वायरल एवं ट्रेंड्स",
          color: "from-pink-500 to-rose-600",
        },
        {
          icon: <FaHospitalAlt />,
          text: "स्वास्थ्य एवं शिक्षा से जुड़ी खबरें",
          color: "from-teal-500 to-cyan-600",
        },
        {
          icon: <FaBriefcase />,
          text: "रोज़गार, व्यापार एवं युवा मुद्दे",
          color: "from-purple-500 to-violet-700",
        },
        {
          icon: <FaCloudSunRain />,
          text: "मौसम एवं प्राकृतिक अपडेट",
          color: "from-sky-500 to-blue-700",
        },
      ].map((item, index) => (
        <div
          key={index}
          className="
            group relative rounded-3xl p-[2px]
            bg-gradient-to-br from-red-600 via-transparent to-black
            hover:scale-[1.04]
            transition-transform duration-500
          "
        >
          <div
            className="
              bg-white rounded-3xl p-10 h-full
              shadow-lg
              group-hover:shadow-2xl
              transition-all duration-500
            "
          >
            {/* Icon */}
            <div
              className={`
                w-20 h-20 mb-6 mx-auto rounded-full
                flex items-center justify-center text-3xl text-white
                bg-gradient-to-br ${item.color}
                shadow-lg
                group-hover:rotate-6 group-hover:scale-110
                transition-all duration-500
              `}
            >
              {item.icon}
            </div>

            {/* Text */}
            <h3 className="text-xl font-bold text-gray-800 text-center leading-snug">
              {item.text}
            </h3>

            {/* Accent */}
            <div className="mt-6 h-1 w-16 mx-auto bg-red-600 rounded-full group-hover:w-28 transition-all duration-500" />
          </div>
        </div>
      ))}
    </div>

  </div>
</section>


      {/* ================= WHY US ================= */}
     <section className="py-16 bg-gray-100">
  <div className="max-w-6xl mx-auto px-4">

    <h2 className="text-3xl md:text-4xl font-extrabold mb-10 text-red-700">
      क्यों चुनें Bundeli Chugli?
    </h2>

    <ul className="space-y-6 text-lg">

      <li className="flex items-start gap-4">
        <span className="text-red-600 text-xl mt-1">
          <FaSearch />
        </span>
        <span className="text-gray-800">
          ज़मीनी हकीकत पर आधारित तथ्यपरक रिपोर्टिंग
        </span>
      </li>

      <li className="flex items-start gap-4">
        <span className="text-red-600 text-xl mt-1">
          <FaLanguage />
        </span>
        <span className="text-gray-800">
          स्थानीय भाषा और स्थानीय संवेदनाओं के साथ प्रस्तुति
        </span>
      </li>

      <li className="flex items-start gap-4">
        <span className="text-red-600 text-xl mt-1">
          <FaBolt />
        </span>
        <span className="text-gray-800">
          तेज़, सटीक और सत्यापित समाचार अपडेट
        </span>
      </li>

      <li className="flex items-start gap-4">
        <span className="text-red-600 text-xl mt-1">
          <FaHeart />
        </span>
        <span className="text-gray-800">
          जनहित और सत्य को सर्वोपरि रखने वाली पत्रकारिता
        </span>
      </li>

      <li className="flex items-start gap-4">
        <span className="text-red-600 text-xl mt-1">
          <FaNewspaper />
        </span>
        <span className="text-gray-800">
          स्वतंत्र, निष्पक्ष और दबाव-मुक्त पत्रकारिता
        </span>
      </li>

    </ul>
  </div>
</section>


      {/* ================= TEAM ================= */}
      {/* <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-bold mb-6 text-red-700">
            👥 हमारी टीम
          </h2>
          <p className="text-lg leading-relaxed mb-4">
            Bundeli Chugli ki team mein ground reporters,
            field journalists, content writers aur digital media experts shamil hain
            jo din-raat mehnat karke khabron ko collect, verify aur publish karte hain.
          </p>
          <p className="text-lg leading-relaxed">
            Humari team ka maksad sirf news dikhana nahi,
            balki samaj mein positive badlav laana bhi hai.
          </p>
        </div>
      </section> */}

      {/* ================= TRUST ================= */}
      <section className="py-16 bg-white text-gray-800 border-t">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">
            🤝 Vishwas aur Zimmedari
          </h2>
          <p className="text-lg max-w-4xl mx-auto">
            Hum apne readers ke vishwas ko sabse badi zimmedari maante hain.
            Isi liye har khabar publish karne se pehle uski jaanch,
            satyata aur prabhav ko dhyaan mein rakha jaata hai.
          </p>
        </div>
      </section>

      {/* ================= QUOTE ================= */}
      <section className="bg-white text-gray-800 py-12 border-t">

        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-xl font-bold italic text-gray-800">
            ❝ Bundeli Chugli & Hindi Chugli –
            Jahan khabar sirf sunai nahi jaati, mehsoos bhi hoti hai. ❞
          </p>

        </div>
      </section>

    </div>
  );
};
export default About;